import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IconPin, IconPinMobile } from '../../../base/icons/svg';
import ContextMenuItem from '../../../base/ui/components/web/ContextMenuItem';
import { NOTIFY_CLICK_MODE } from '../../../toolbox/types';
import Icon from "../../../base/icons/components/Icon";
import { isMobileBrowser } from "../../../base/environment/utils";
import { pinParticipant } from "../../../base/participants/actions";
import { getParticipantByIdOrUndefined } from "../../../base/participants/functions";
import ContextMenuItemMobile from "../../../base/ui/components/web/ContextMenuItemMobile";
const TogglePinToStageButton = ({ className, textClassName, noIcon = false, notifyClick, notifyMode, onClick, participantID }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const participant = useSelector((state) => getParticipantByIdOrUndefined(state, participantID));
    const isActive = Boolean(participant?.pinned);
    const _onClick = useCallback(() => {
        notifyClick?.();
        if (notifyMode === NOTIFY_CLICK_MODE.PREVENT_AND_NOTIFY) {
            return;
        }
        dispatch(pinParticipant(isActive ? null : participantID));
        onClick?.();
    }, [dispatch, isActive, notifyClick, onClick, participantID]);
    const isMobile = isMobileBrowser();
    const text = isMobile
        ? t('videothumbnail.show')
        : isActive
            ? t('videothumbnail.unpinFromStage')
            : t('videothumbnail.pinToStage');
    if (isMobile) {
        return (React.createElement(ContextMenuItemMobile, { accessibilityLabel: text, icon: undefined, customIcon: noIcon ? undefined : React.createElement(Icon, { className: isMobile ? 'is-mobile' : '', size: isMobile ? 22 : 18, src: IconPinMobile, color: 'rgba(255, 255, 255, 0.3) !important' }), onClick: _onClick, text: text, className: className, textClassName: textClassName }));
    }
    return (React.createElement(ContextMenuItem, { accessibilityLabel: text, icon: undefined, customIcon: noIcon ? undefined : React.createElement(Icon, { className: isMobile ? 'is-mobile' : '', size: isMobile ? 22 : 18, src: IconPin, color: 'rgba(255, 255, 255, 0.3)' }), onClick: _onClick, text: text, className: className, textClassName: textClassName }));
};
export default TogglePinToStageButton;
